import React, { PureComponent } from 'react'
import XCustomHeader from 'xui/components/XCustomHeader'
import BaseSellerStoresView from 'x/modules/storeSeller/BaseSellerStoresView'
import XContainer from 'xui/components/XContainer'
import XContent from 'xui/components/XContent'
import _ from 'lodash'
import * as util from 'x/utils/util'
import VStack from 'xui/components/VStack'
import { COLORS, STYLES } from 'x/config/styles'
import HStack from 'xui/components/HStack'
import XText from 'xui/components/XText'
import XInput from 'xui/components/XInput'
import XButton from 'xui/components/XButton'
import XIcon from 'xui/components/XIcon'
import { APP_CONFIG } from 'x/config/mode'
import XModal from 'xui/components/XModal'
import XSpinner from 'xui/components/XSpinner'
import CONS from 'x/config/constants'
import * as NavActions from 'x/utils/navigation'
import XCard from 'xui/components/XCard'
import XImage from 'xui/components/XImage'
import Box from 'xui/components/Box'
import { ImageBackground } from 'react-native'
import p from 'x/config/platform-specific'
import StoreCard from './StoreCard'
import UGDisplayItem from './UGDisplayItem'

export default class BaseUISellerStoresView extends BaseSellerStoresView {
  // static displayName = 'BaseUIStoreSettingBillView'

  renderHeader = () => (
    <XCustomHeader
      title={'ร้านผู้ขายส่ง'}
      headerLeftProps={{
        backIcon: true,
        onPressItem: () => {
          util.navGoBack(this.props)
        },
      }}
    />
  )

  _renderLoadQrFromGalleryButton = () => {
    // @ts-ignore
    const { submitting, decoding, decodedQRSrc } = this.state
    const isDisabled = submitting || decoding || (_.isString(decodedQRSrc) && decodedQRSrc.length > 0)
    return (
      <VStack w='full' p='2' pt='10' alignItems='center' space='2'>
        <XButton
          disabled={isDisabled}
          h='12'
          w='full'
          leftIcon={<XIcon name='qrcode-scan' family='MaterialCommunityIcons' />}
          onPress={this._handleOnPickQrCode}>
          เลือกรูป QR Code จากคลังรูปภาพ
        </XButton>
        <XText variant='inactive'>หรือ</XText>
        <XText>สแกน QR Code ด้วยกล้อง</XText>
      </VStack>
    )
  }

  _renderFoundSellerStore = () => {
    // const { txtInviteCode } = this.state
    const { foundSellerStore, foundOldUg, foundNewUg } = this.state
    if (!foundSellerStore || !foundSellerStore.id || !foundSellerStore.name) {
      return null
    }

    const {
      // id,
      name,
      description = null,
      // img_uri = null,
      // thumbnail_uri = null,
      // cover_uri = null,
      cover_thumbnail_uri = null,
    } = foundSellerStore

    // 820 x 462 facebook cover ratio = 1.7748917749 / 0.5634146341
    const coverWidth = this.SCREEN_WIDTH
    // console.log('coverWidth => ', coverWidth)
    const coverHeight = Math.round(0.5634146341 * this.SCREEN_WIDTH)
    const profileSize = 75
    // const profileSize = 128

    const txtName = name || '(ไม่พบชื่อร้านค้า)'
    const txtDesc = description || '(ไม่มีคำอธิบายร้าน)'
    // console.log('foundOldUg => ', foundOldUg)
    // console.log('foundNewUg => ', foundNewUg)
    return (
      <VStack key='cover' w='full'>
        <HStack
          w='full'
          style={{
            // width: coverWidth,
            height: 150,
            // backgroundColor: 'transparent',
            // backgroundColor: COLORS.RED,
          }}>
          <VStack flex={1}>
            {cover_thumbnail_uri ? (
              <ImageBackground resizeMode='cover' style={{ flex: 1, height: 150 }} source={{ uri: cover_thumbnail_uri }} />
            ) : null}

            <Box left='8' top='24' position='absolute' zIndex={999}>
              <XText
                variant='activeDark'
                fontSize='lg'
                bold
                numberOfLines={2}
                style={{
                  textShadowColor: 'black',
                  textShadowRadius: 10,
                  textShadowOffset: { width: 1, height: -1 },
                }}>
                {txtName}
              </XText>
            </Box>
          </VStack>
        </HStack>
        <VStack w='full' p='2'>
          <XText variant='inactive'>คำอธิบายร้าน</XText>
          <XText numberOfLines={6}>{txtDesc}</XText>
        </VStack>

        {/* // Read me UI นี้จะแสดงก็ต่อเมื่อ นาย A อยู่กลุ่มสมาชิก(UG) ลูกค้าขายดี(ตัวอย่างชื่อกลุ่ม) แล้วได้รับคำเชิญให้ย้ายไปกลุ่มสมาชิก(UG) 
        // ลูกค้าชั้นยอดส่วนลดพิเศษ(ตัวอย่างชื่อกลุ่ม) เมื่อนาย A ใส่ Code สมัครไปยังกลุ่มใหม่ UI ถึงจะแสดง */}
        {foundOldUg && foundNewUg ? (
          <VStack flex={1} alignItems='center' pt='3' space='1' mx='2'>
            <XCard w='full' p='1' h={'70px'} m='2'>
              <UGDisplayItem {...foundOldUg} />
              <XText variant='inactive' fontSize='xs' style={{ position: 'absolute', top: 2, right: 2 }}>
                (กลุ่มปัจจุบัน)
              </XText>
            </XCard>

            <XIcon family='FontAwesome' name='arrow-down' />

            <XCard w='full' p='1' h={'70px'} m='2'>
              <UGDisplayItem {...foundNewUg} />
              <XText variant='inactive' fontSize='xs' style={{ position: 'absolute', top: 2, right: 2 }}>
                (กลุ่มใหม่)
              </XText>
            </XCard>
          </VStack>
        ) : null}
      </VStack>
    )
  }

  _renderInvitationModal = () => {
    const isVisibleCamera = _.has(this.state, 'isVisibleCamera') ? this.state.isVisibleCamera : false
    const foundSellerStore = _.has(this.state, 'foundSellerStore') ? this.state.foundSellerStore : null
    const foundOldUg = _.has(this.state, 'foundOldUg') ? this.state.foundOldUg : null
    const foundNewUg = _.has(this.state, 'foundNewUg') ? this.state.foundNewUg : null
    const submitting = _.has(this.state, 'submitting') ? this.state.submitting : false
    const decoding = _.has(this.state, 'decoding') ? this.state.decoding : false
    const isVisibleModal = _.has(this.state, 'isVisibleModal') ? this.state.isVisibleModal : false
    // const decodedQRSrc = _.has(this.state, 'decodedQRSrc') ? this.state.decodedQRSrc : null
    // console.log('foundSellerStore => ', foundSellerStore)
    let txtModalHeader
    if (isVisibleCamera) {
      txtModalHeader = 'สแกน QR Code ขอเข้าร่วมร้าน'
    } else if (submitting) {
      txtModalHeader = 'กำลังโหลดข้อมูล'
    } else if (!submitting && foundSellerStore && (!foundOldUg || !foundNewUg)) {
      txtModalHeader = 'ยืนยันการสมัครสมาชิก'
      // @ts-ignore
    } else if (!submitting && foundSellerStore && foundOldUg && foundNewUg && foundOldUg.name && foundNewUg.name) {
      txtModalHeader = 'ยืนยันการขอย้ายกลุ่มสมาชิก'
    }

    const isDisabledCloseButton = submitting || decoding

    console.log('submitting => ', submitting)
    console.log('foundSellerStore => ', foundSellerStore)
    return (
      <XModal
        visible={isVisibleModal}
        title={txtModalHeader}
        // hasBackButton={true}
        hasCloseButton
        // contentStyle={{ alignItems: 'center', backgroundColor: 'white' }}
        onRequestClose={this._onRequestCloseModal}>
        <VStack w='full' flex={1}>
          {!submitting && !foundSellerStore ? this._renderLoadQrFromGalleryButton() : null}
          {submitting ? <XSpinner size='sm' color={COLORS.APP_MAIN} /> : null}
          {/* {!submitting && isVisibleCamera ? this._renderQRScanner() : null} */}
          {!submitting && !_.isNull(foundSellerStore) ? this._renderFoundSellerStore() : null}
        </VStack>
        {!submitting && !_.isNull(foundSellerStore) ? this._renderFoundSellerStoreFooterButton() : null}
      </XModal>
    )
  }

  _renderFoundSellerStoreFooterButton = () => {
    const { submitting, txtInviteCode, foundSellerStore, foundOldUg, foundNewUg } = this.state
    if (!foundSellerStore || !foundSellerStore.id || !foundSellerStore.name) {
      return null
    }

    let txtSubmitButton = 'สมัครเป็นสมาชิก'
    if (foundOldUg && foundNewUg && foundOldUg.name && foundNewUg.name) {
      txtSubmitButton = 'ขอย้ายกลุ่มสมาชิก'
    }

    return (
      <HStack w='full' minH='12' p='2' style={STYLES.FOOTER_BG}>
        <XButton disabled={submitting} w='full' onPress={this._onPressSubmitConfirmToJoin}>
          {txtSubmitButton}
        </XButton>
      </HStack>
    )
  }

  _onPressSubmitConfirmToJoin = () => {
    const txtInviteCode = _.has(this.state, 'txtInviteCode') ? this.state.txtInviteCode : null
    this._handleSubmitInvitationCode(txtInviteCode, true)
  }

  _renderBeforeStoreList = () => {
    if (!APP_CONFIG.seller_stores.show_reseller_registration_box) {
      return null
    }

    const txtInviteCode = _.has(this.state, 'txtInviteCode') ? this.state.txtInviteCode : ''
    const submitting = _.has(this.state, 'submitting') ? this.state.submitting : false
    const disabledSubmitButton = !txtInviteCode || txtInviteCode.length === 0
    let showScanQRCodeButton = true
    // จะแสดงปุ่มสแกน QR Code ก็ต่อเมื่อ ไม่ใช่ platform web และถ้าเป็น app ให้แก้ไขใหม่เอง
    if (p.op.isWeb()) {
      showScanQRCodeButton = false
    } else {
      showScanQRCodeButton = false
    }
    return (
      <VStack
        w='full'
        py='2'
        px='3'
        borderBottomWidth='1'
        borderBottomColor={COLORS.BG_LIGHT_GREY_ALTERNATIVE}
        // style={{
        //   width: '100%',
        //   paddingVertical: 6,
        //   paddingHorizontal: 12,
        //   backgroundColor: 'white',
        //   borderBottomWidth: 1,
        //   // borderBottomColor: STYLES.TEXT_INACTIVE,
        //   borderBottomColor: COLORS.BG_LIGHT_GREY_ALTERNATIVE,
        // }}
      >
        {this._renderInvitationModal()}
        <HStack w='full'>
          <VStack>
            <XText
              bold
              style={{
                fontSize: STYLES.FONT_SIZE_NORMAL,
                color: COLORS.TEXT_ACTIVE,
                // fontWeight: 'bold',
              }}>
              สมัครเป็นสมาชิก
            </XText>
          </VStack>
        </HStack>
        <HStack w='full' py='1' space='2'>
          <XInput
            flex={1}
            // w='120px'
            maxW='200px'
            // style={{ fontSize: STYLES.FONT_SIZE_NORMAL }}
            placeholder='ระบุรหัส 5 ตัว'
            onChangeText={this._onChangeInviteCode}
            value={txtInviteCode}
          />

          <HStack justifyContent='center' alignItems='center' space='1'>
            <XButton
              w='90px'
              disabled={disabledSubmitButton || submitting}
              isDisabled={disabledSubmitButton || submitting}
              onPress={this._onPressManualSubmitInviteCode}
              // style={{ borderRadius: 3, width: '100%', height: '96%' }}
              justifyContent='center'
              alignItems='center'>
              <XText color='white' pb='2px'>
                สมัคร
              </XText>
            </XButton>
            {showScanQRCodeButton ? (
              <HStack>
                <XText variant='inactive' bold>
                  หรือ
                </XText>
                <XButton
                  w='120px'
                  disabled={submitting}
                  leftIcon={<XIcon name='qrcode-scan' family='MaterialCommunityIcons' />}
                  // onPress={ () => this.setState({ isVisibleModal: true, isVisibleCamera: true, foundSellerStore: null }) }
                  onPress={this._onPressInsertInviteWithScanQRCode}>
                  สแกน QR
                </XButton>
              </HStack>
            ) : null}
          </HStack>
        </HStack>
      </VStack>
    )
  }
  // LHG92
  _renderByMode = (data, index) => {
    // console.log('MODE => ', this.mode)
    switch (this.mode) {
      case CONS.STORES_MODE_MY_VIEW:
        return this._renderCard(index, data)
      case CONS.STORES_MODE_SELLER_VIEW:
        return this._renderListItem(index, data)
      case CONS.STORES_MODE_SELLER_PULL_PRODUCT:
        return this._renderListItem(index, data)
      default:
        return this._renderCard(index, data)
    }
  }

  renderStoreListItems = () => {
    const stores = this._getStores() || []
    // console.log('stores => ', stores.toJS())
    return stores.map(this._renderByMode)
  }

  onPressStore = (index, rowData) => {
    const storeId = rowData.get('id')
    if (!storeId) {
      return
    }
    this.props.navigation.dispatch(
      NavActions.navToStoreSellerView({
        rowData: rowData.toJS(),
        callBackLeaveSuccess: () => this._onRefresh(),
      })
    )
    // this.props.navigation.navigate('StoreSellerView', rowData.toJS())
  }

  _renderCard = (index, rowData) => (
    // log('_renderCard')
    // log(rowData.toJS())
    // const id = rowData.get('id')
    // const name = rowData.get('name')
    // const role_id = rowData.get('role_id') || xCONS.STORE_ROLE.OWNER // default to 1
    <StoreCard
      key={`StoreCard_${index}`}
      index={index}
      // id={id}
      // name={name}
      // role_id={role_id}
      // imgUri={rowData.get('cover_thumbnail_uri')}
      data={rowData}
      lastUpdated='7 นาทีที่แล้ว'
      myTaskCount={this._getMyTasksCount()}
      showCreateOrder={this._getShowCreateOrder()}
      onPress={_.isFunction(this.onPressStore) ? this.onPressStore : null}
    />
  )

  _renderListItem = (index, rowData) => (
    // log('_renderListItem rowData => ', rowData)
    <StoreListItem
      key={`StoreListItem_${index}`}
      index={index}
      // onPressStore={this.onPressStore}
      onPressStore={_.isFunction(this.onPressStore) ? this.onPressStore : null}
      data={rowData}
    />
  )

  _getMyTasksCount = () => {
    switch (this.mode) {
      case CONS.STORES_MODE_MY_VIEW:
        return 6
      case CONS.STORES_MODE_SELLER_VIEW:
        return -1
      case CONS.STORES_MODE_SELLER_PULL_PRODUCT:
        return -1
      default:
        return false
    }
  }

  _getShowCreateOrder = () => {
    switch (this.mode) {
      case CONS.STORES_MODE_MY_VIEW:
        return true
      case CONS.STORES_MODE_SELLER_VIEW:
        return false
      case CONS.STORES_MODE_SELLER_PULL_PRODUCT:
        return false
      default:
        return false
    }
  }

  render() {
    return (
      <XContainer>
        {this.renderHeader()}
        {this._renderBeforeStoreList()}
        <XContent>{this.renderStoreListItems()}</XContent>
      </XContainer>
    )
  }
}

class StoreListItem extends PureComponent {
  _onPressStore = () => {
    if (!APP_CONFIG.seller_stores.can_select_store) {
      return null
    }
    const { index, data, onPressStore } = this.props
    if (_.isFunction(onPressStore)) {
      onPressStore(index, data)
    }
  }

  render() {
    const { data } = this.props
    if (!Map.isMap(data)) {
      return null
    }

    // const id = data.get('id')
    const name = data.get('name')
    const description = data.get('description') || null
    const cover_thumbnail_uri = data.get('cover_thumbnail_uri') || null
    const isPendingStore = data.has('isPending')
    const showArrowIcon = APP_CONFIG.seller_stores.can_select_store

    return (
      <XCard w='full' disabled={isPendingStore} opacity={isPendingStore ? 0.7 : 1} onPress={this._onPressStore}>
        <XCard.Body>
          <HStack w='full' py='1' space='2' alignItems='center'>
            <XImage
              // square
              // size={80}
              source={{ uri: cover_thumbnail_uri }}
              borderRadius='lg'
              style={{
                height: 56,
                width: 56,
              }}
            />

            {/* <Body style={{ flex: 7, paddingLeft: 5, justifyContent: 'flex-start', alignItems: 'flex-start' }}> */}
            <VStack flex={1} p='2'>
              <XText allowFontScaling={false} numberOfLines={1} variant={isPendingStore ? 'inactive' : 'active'} fontSize='md'>
                {name}
              </XText>

              <XText allowFontScaling={false} numberOfLines={2} variant='inactive'>
                {description || '(ไม่มีคำอธิบายร้าน)'}
              </XText>
            </VStack>

            {isPendingStore || !showArrowIcon ? null : <XIcon name='arrow-forward' />}

            {isPendingStore ? (
              <XText allowFontScaling={false} numberOfLines={1} position='absolute' bottom='0' right='0' textAlign='right'>
                รอการอนุมัติคำขอเข้ากลุ่ม
              </XText>
            ) : null}
          </HStack>
        </XCard.Body>
      </XCard>
    )
  }
}
